import Vue from "vue";

Vue.component("threshold-management", {
    props: ["thresholds", "hasEntity", "nationalCurrency", "modificationModel"],
    data() {
        return {
            id: 0,
            annexId: 0,
            loading: false,
            revisionModel: this.modificationModel,
            thresholdTypes: ['Architectural, engineering and other technical services', 'BOTs', 'Construction services', 'Goods', 'Services'],
            thresholdType: null,
            displayNameEn: null,
            displayNameFr: null,
            displayNameEs: null,
            value: 0,
            displayOrder: 0,
            showFormModal: false
        };
    },
    methods: {
        editThreshold(threshold) {
            const self = this;

            self.loading = true;
            self.showFormModal = true;

            self.$services.thresholds.getById({
                id: threshold.id
            }).then((data) => {
                self.loading = false;
                self.id = data.id;
                self.thresholdType = data.type;
                self.displayNameEn = data.displayNameEn;
                self.displayNameEs = data.displayNameEs;
                self.displayNameFr = data.displayNameFr;
                self.displayOrder = data.displayOrder;
                self.value = data.value;
            });
        },
        discard() {
            const self = this;

            self.id = 0;
            self.thresholdType = null;
            self.displayNameEn = null;
            self.displayNameEs = null;
            self.displayNameFr = null;
            self.displayOrder = 0;
            self.value = 0;
            self.showFormModal = false;
        },
        save() {
            const self = this;

            self.$services.thresholds.save({
                id: self.id,
                type: self.thresholdType,
                displayNameEn: self.displayNameEn,
                displayNameEs: self.displayNameEs,
                displayNameFr: self.displayNameFr,
                displayOrder: self.displayOrder,
                value: self.value
            }).then((data) => {
                if (data) {
                    const self = this;

                    self.showFormModal = false;
                    self.revisionModel.updatedThresholdCount += 1;
                    self.$emit('update:modificationModel', self.revisionModel);
					self.$buefy.snackbar.open(window.messages.thresholdSuccessfullyStored);
                }
                else {
					self.$buefy.snackbar.open(window.messages.thresholdUnsuccessfullyStored);
                }
            });
        }

    },
    computed: {
        thresholdsForLabel: function () {
            return window.labels.thresholdsFor;
        }
    },
    template: `
		<div class="annex-thresholds">
			<b-table :data="thresholds" detail-key="id">
				<b-table-column :label="thresholdsForLabel">
					<template v-slot="props">
						<span @click="editThreshold(props.row)" v-html="props.row.displayName"></span>
					</template>
				</b-table-column>
				<b-table-column label="SDR" width="100px" cell-class="has-text-right" header-class="has-text-right">
					<template v-slot="props">
                        <span @click="editThreshold(props.row)">{{ props.row.sdrValue }}</span>
					</template>
				</b-table-column>
				<b-table-column width="100px" v-if="nationalCurrency" :label="nationalCurrency" cell-class="has-text-right" header-class="has-text-right">
					<template v-slot="props">                            
                        <span @click="editThreshold(props.row)">{{ props.row.currencyValue }}</span>
				</template>
				<b-table-column width="100px" v-if="hasEntity">
					<template v-slot="props" @click="editThreshold(props.row)">
						<span @click="editThreshold(props.row)"> {{ props.row.entityName }}</span>
					</template>
				</b-table-column>				
			</b-table>
			<b-modal id="thresholdFormModal" ref="thresholdFormModal" v-model="showFormModal" #default="props" :can-cancel="['x']">
			    <div class="modal-card">
					<header class="modal-card-head">
                        <p class="modal-card-title">Edit Threshold - <b>{{id}}</b></p>
                        <button type="button" class="delete" @click="discard"/>
                    </header>
                    <section class="modal-card-body">
						<div class="card">
							<div class="card-content">                            
								<template v-if="loading"><loading></loading></template>
								<template v-else>
									<div class="content">
										<div class="columns">
											<div class="column">                                            
												<b-field class="mb-0 p-0 metadata-control" label="Threshold type">
													<b-select v-model="thresholdType">
														<option
															v-for="option in thresholdTypes"
															:value="option"
															:key="option">
															{{ option }}
														</option>
													</b-select>
												</b-field>
											</div>                                        
										</div>
										<div class="columns">
											<div class="column">                                            
												<b-field label="Text (English)">
													<b-input v-model="displayNameEn"></b-input>
												</b-field>
											</div>
										</div>
										<div class="columns">
											<div class="column">                                            
												<b-field label="Text (French)">
													<b-input v-model="displayNameFr"></b-input>
												</b-field>
											</div>
										</div>
										<div class="columns">
											<div class="column">                                            
												<b-field label="Text (Spanish)">
													<b-input v-model="displayNameEs"></b-input>
												</b-field>
											</div>
										</div>									                                    
										<div class="columns">
											<div class="column">                                            
												<b-field label="Value">
												  <b-numberinput v-model="value"></b-numberinput>
												</b-field>
											</div>
											<div class="column">
												<b-field label="Display order">
												  <b-numberinput v-model="displayOrder"></b-numberinput>
												</b-field>
											</div>
										</div>                                    
									</div>
								</template>
							</div>
							<div class="card-footer">
								<div class="buttons">
									<button type="button" class="button is-primary" @click="save">Save</button>
									<button type="button" class="button is-danger" @click="discard">Discard</button>
								</div>
							</div>
						</div>  
					</section>
                </div>
		    </b-modal>
		</div>
	`
});